/**
 * A base class for creating component managers for the FS Design System
 * @abstract
 */
export class ComponentManagerBase extends EventTarget {
    /**
     * Whether or not the manager is currently "connected", i.e. required event listeners are added and listening.
     */
    get isConnected() {
        return this.connectedController != null;
    }
    /**
     * Event listener options including an abort signal so the listener is automatically removed when the component is
     * disconnected.
     */
    get abortableEventListenerOptions() {
        if (!this.isConnected) {
            throw new Error('Cannot get event listener options for manager when not connected.');
        }
        return { signal: this.connectedController?.signal };
    }
    /**
     * Connects the manager to the DOM elements it is managing, adding required event listeners.
     */
    connect() {
        if (this.isConnected) {
            throw new Error('This manager is already connected.');
        }
        this.connectedController = new AbortController();
    }
    /**
     * Disconnects the manager from the DOM elements it is managing, removing attached event listeners.
     */
    disconnect() {
        if (!this.isConnected) {
            throw new Error('This manager is not connected.');
        }
        this.connectedController.abort();
        this.connectedController = null;
    }
}
//# sourceMappingURL=component-manager-base.js.map